// extracted by mini-css-extract-plugin
export default {"wrapper":"OfferTableControls_wrapper__L4t-e","controls":"OfferTableControls_controls__4KmtZ","clearButton":"OfferTableControls_clearButton__oLZ2V"};